// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9b91f338","453":"eca5f793"}[chunkId] + ".chunk.js";
};